var map = {
	"./images/20240115jiagou.png": "./src/assets/images/20240115jiagou.png",
	"./images/20240115juese.png": "./src/assets/images/20240115juese.png",
	"./images/20240115yonghuzu.png": "./src/assets/images/20240115yonghuzu.png",
	"./images/20240116u_jiagou.png": "./src/assets/images/20240116u_jiagou.png",
	"./images/20240116u_juese.png": "./src/assets/images/20240116u_juese.png",
	"./images/20240116u_yonghuzu.png": "./src/assets/images/20240116u_yonghuzu.png",
	"./images/20240118touxiang.png": "./src/assets/images/20240118touxiang.png",
	"./images/20240119home.png": "./src/assets/images/20240119home.png",
	"./ioc/Group 1000005356.png": "./src/assets/ioc/Group 1000005356.png",
	"./ioc/Group05661.png": "./src/assets/ioc/Group05661.png",
	"./ioc/Group_1000005290.png": "./src/assets/ioc/Group_1000005290.png",
	"./ioc/Group_1000005379.png": "./src/assets/ioc/Group_1000005379.png",
	"./ioc/Group_1000005473.png": "./src/assets/ioc/Group_1000005473.png",
	"./ioc/Group_1000005517.png": "./src/assets/ioc/Group_1000005517.png",
	"./ioc/Group_1000005519.png": "./src/assets/ioc/Group_1000005519.png",
	"./ioc/Group_1000005636.png": "./src/assets/ioc/Group_1000005636.png",
	"./ioc/Group_1000005637.png": "./src/assets/ioc/Group_1000005637.png",
	"./ioc/Group_1000005649.png": "./src/assets/ioc/Group_1000005649.png",
	"./ioc/Group_1209.png": "./src/assets/ioc/Group_1209.png",
	"./ioc/Group_1x.png": "./src/assets/ioc/Group_1x.png",
	"./ioc/Group_41.png": "./src/assets/ioc/Group_41.png",
	"./ioc/angle-down-ci.png": "./src/assets/ioc/angle-down-ci.png",
	"./ioc/angle-down-circle.png": "./src/assets/ioc/angle-down-circle.png",
	"./ioc/angle-left.png": "./src/assets/ioc/angle-left.png",
	"./ioc/arrow-back.png": "./src/assets/ioc/arrow-back.png",
	"./ioc/arrow-export.png": "./src/assets/ioc/arrow-export.png",
	"./ioc/arrow-forward@2x.png": "./src/assets/ioc/arrow-forward@2x.png",
	"./ioc/arrow-up-from-line.png": "./src/assets/ioc/arrow-up-from-line.png",
	"./ioc/arrow-up-right.png": "./src/assets/ioc/arrow-up-right.png",
	"./ioc/arrows-repeat.png": "./src/assets/ioc/arrows-repeat.png",
	"./ioc/bell@2x.png": "./src/assets/ioc/bell@2x.png",
	"./ioc/chart-bar-alt.png": "./src/assets/ioc/chart-bar-alt.png",
	"./ioc/chat.png": "./src/assets/ioc/chat.png",
	"./ioc/check-circle.png": "./src/assets/ioc/check-circle.png",
	"./ioc/check-double.png": "./src/assets/ioc/check-double.png",
	"./ioc/check2.png": "./src/assets/ioc/check2.png",
	"./ioc/check3.png": "./src/assets/ioc/check3.png",
	"./ioc/check4.png": "./src/assets/ioc/check4.png",
	"./ioc/clipboard-edit@2x.png": "./src/assets/ioc/clipboard-edit@2x.png",
	"./ioc/clipboard-list.png": "./src/assets/ioc/clipboard-list.png",
	"./ioc/download.png": "./src/assets/ioc/download.png",
	"./ioc/download@2x.png": "./src/assets/ioc/download@2x.png",
	"./ioc/empty.png": "./src/assets/ioc/empty.png",
	"./ioc/exclamation-circle.png": "./src/assets/ioc/exclamation-circle.png",
	"./ioc/exclircle.png": "./src/assets/ioc/exclircle.png",
	"./ioc/eye.png": "./src/assets/ioc/eye.png",
	"./ioc/file-copy.png": "./src/assets/ioc/file-copy.png",
	"./ioc/home-dash.png": "./src/assets/ioc/home-dash.png",
	"./ioc/hourglass.png": "./src/assets/ioc/hourglass.png",
	"./ioc/info-circle.png": "./src/assets/ioc/info-circle.png",
	"./ioc/menu-right-alt.png": "./src/assets/ioc/menu-right-alt.png",
	"./ioc/minus-circle.png": "./src/assets/ioc/minus-circle.png",
	"./ioc/more-horizontal.png": "./src/assets/ioc/more-horizontal.png",
	"./ioc/nut.png": "./src/assets/ioc/nut.png",
	"./ioc/pen.png": "./src/assets/ioc/pen.png",
	"./ioc/plus-add.png": "./src/assets/ioc/plus-add.png",
	"./ioc/plus-circle.png": "./src/assets/ioc/plus-circle.png",
	"./ioc/print.png": "./src/assets/ioc/print.png",
	"./ioc/rotate-left.png": "./src/assets/ioc/rotate-left.png",
	"./ioc/send.png": "./src/assets/ioc/send.png",
	"./ioc/times-circle.png": "./src/assets/ioc/times-circle.png",
	"./ioc/trash.png": "./src/assets/ioc/trash.png",
	"./ioc/复制_o.png": "./src/assets/ioc/复制_o.png",
	"./logo.png": "./src/assets/logo.png",
	"./logo.svg": "./src/assets/logo.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*$";